import React from "react";
import { history } from "../utils/history";
/*
import {
    PlaceHolderModal,
    EditProfile,
    JitsiMeeting,
    Customer,
    AppointmentModal,
    News,
    Assessment,
    OnBoarding,
    Wallet,
    Subscription,
    CyberRiskDetails,
    ChangePassword
} from "../../_pages";*/
/*
    import { FindAgent } from "../modals/FindAgent";
*/

import { AddUserPage, EditUserPage } from "../pages";

export class QuickModalRouter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: true,
      additionalPar: this.props.match.params.additionalPar,
      location: this.props.location,
      businessId: this.props.match.params.businessId,
      orderId: this.props.match.params.orderId,
      id: this.props.match.params.id,
      room: this.props.match.params.room,
    };
  }

  toggleModal = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });

    history.goBack();
  };

  switchModal = (location) => {
    const { additionalPar, businessId, orderId, id, room } = this.state;

    const propsToPage = {
      toggleModal: this.toggleModal,
      additionalPar,
      location,
      businessId,
      orderId,
      id,
      room,
      isOpen: true,
      closeModal: this.toggleModal,
    };

    // if(location.pathname.includes('/store/')) return <StoreModal        {...propsToPage} />;
    // if(location.pathname.includes('/cart/')) return <Cart               {...propsToPage} />;
    // if(location.pathname.includes('/order/')) return <Order                {...propsToPage} />;
    // if(location.pathname.includes('/profile/password/change')) return <ChangePassword  {...propsToPage} />;
    // if(location.pathname.includes('/profile')) return <EditProfile         {...propsToPage} />;
    // if(location.pathname.includes('/jitsi')) return <JitsiMeeting              {...propsToPage} />;
    // if(location.pathname.includes('/booking')) return <FindAgent           {...propsToPage} />;
    // if(location.pathname.includes('/customer')) return <Customer           {...propsToPage} />;
    // if(location.pathname.includes('/news')) return <News                   {...propsToPage} />;
    // if(location.pathname.includes('/appt')) return <AppointmentModal       {...propsToPage} />;
    // if(location.pathname.includes('/assessment')) return <Assessment       {...propsToPage} />;
    // if(location.pathname.includes('/onboarding')) return <OnBoarding       {...propsToPage} />;
    // if(location.pathname.includes('/wallet')) return <Wallet               {...propsToPage} />;
    // if(location.pathname.includes('/subscription')) return <Subscription   {...propsToPage} />;
    // if(location.pathname.includes('/cyberrisk/details')) return <CyberRiskDetails   {...propsToPage} />;

    if (location.pathname.includes("/users/new"))
      return <AddUserPage {...propsToPage} />;
    if (location.pathname.includes("/users/edit"))
      return <EditUserPage {...propsToPage} />;

    //history.goBack();
  };

  render() {
    return this.switchModal(this.state.location);
    /*return (
            <QuickModalContainer show={this.state.isOpen} onClose={this.toggleModal}>

                <Flex column
                    style={{
                        color: theme.white,
                        height: "100%",
                    }}>
                    {
                        this.switchModal(this.state.action)
                    }

                </Flex>

            </QuickModalContainer>
        );*/
  }
}
